const getPriceCard = (monto) => {
    return monto * 0.05;
};

export default getPriceCard;
